import { SalaryAdvanceSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CapPercentageSetting from 'modules/salary_advance/pages/settings/Content/CapPercentageSetting'
import ClosureDaySetting from 'modules/salary_advance/pages/settings/Content/ClosureDaySetting'

const SalaryAdvanceSettingsPage = () => {
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(SalaryAdvanceSettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const companySetting = data?.salaryAdvance?.companySettingsConnection?.nodes?.[0]
  const canEdit = data?.salaryAdvance?._policies?.manageSalaryAdvance?.can ?? false
  // can be null (meaning no cap limit is set)
  const advanceCapMonthlyWagePercent = companySetting?.advanceCapMonthlyWagePercent
  // is required and always has a value
  const requestDeadlineDay = companySetting?.requestDeadlineDay

  if (!companySetting || requestDeadlineDay == null) {
    return (
      <ResponsivePage.Body loading={loading} error={error} showHeader={false}>
        {null}
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body showHeader={false}>
      <CapPercentageSetting
        companyId={company.id}
        currentCapPercentage={advanceCapMonthlyWagePercent}
        requestDeadlineDay={requestDeadlineDay}
        canEdit={canEdit}
      />
      <ClosureDaySetting requestDeadlineDay={requestDeadlineDay} />
    </ResponsivePage.Body>
  )
}

export default SalaryAdvanceSettingsPage
